import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'newLineReplacerPipe',
})
export class NewLineReplacerPipe implements PipeTransform {
  transform(str: string): string {
    return !!str ? str.replace(/\n/g, `<br>`) : str;
  }
}
